import * as React from "react";
import { capitalize } from "../engine/Utils";
import { RoundData, getTeamScore } from "../engine/RoundData";
import { Player } from "../engine/Player";

export interface IScoreboardProps {
    players: Player[],
    rounds: RoundData[]
}

export class ScoreboardComponent extends React.Component<IScoreboardProps> {

    getTeamPlayers(teamIndex: number) {
        return this.props.players.
            filter((_, i) => i === (teamIndex) || i === (teamIndex + 2));
    }

    public render () {
        const team1 = this.getTeamPlayers(0);
        const team1Score = getTeamScore(this.props.rounds, 0);

        const team2 = this.getTeamPlayers(1);
        const team2Score = getTeamScore(this.props.rounds, 1);

        return (
            <table className="scoreboard" cellPadding={0} cellSpacing={0}>
                <thead>
                    <tr>
                        <td>Team</td>
                        <td>Score</td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{ team1.map(player => capitalize(player.name)).join(" & ") }</td>
                        <td>{ team1Score }</td>
                    </tr>
                    <tr>
                        <td>{ team2.map(player => capitalize(player.name)).join(" & ") }</td>
                        <td>{ team2Score }</td>
                    </tr>
                </tbody>
            </table>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/ScoreboardComponent.tsx